import React from "react";
import "./styles.less";
// import { Button } from "../../components/Button";

import { Link } from "../../components/Link";
import { useTranslation } from "react-i18next";

export const SolutionWechatContent = () => {
  const { t } = useTranslation();

  return (
    <div className="wechat-content">
      <section className="mini-login-scan">
        <div className="inner">
          <div className="content-warp">
            <div className="content-img">
              <img
                src={"//files.authing.co/authing-website/wechat-mini-login-scan.png"}
                alt="authing wechat login-scan"
              />
            </div>
            <div className="content-text">
              <div>
                <div className="title">{t("solution.wechat.mini-login-scan.title")}</div>
                <div className="description">
                  {t("solution.wechat.mini-login-scan.content")}
                  <Link
                    href="https://docs.authing.cn/v2/guides/wechat-ecosystem/wechat-miniprogram-qrcode/"
                    target="_blank"
                  >
                    {t("common.linkDoc")}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="pc-scan-login" style={{ background: "rgba(49,172,97,0.04)" }}>
        <div className="inner">
          <div className="content-warp">
            <div className="content-text">
              <div>
                <div className="title">{t("solution.wechat.pc-scan-login.title")}</div>
                <div className="description">
                  {t("solution.wechat.pc-scan-login.content")}
                  <Link href="https://docs.authing.cn/v2/guides/wechat-ecosystem/wechat-pc/" target="_blank">
                    {t("common.linkDoc")}
                  </Link>
                </div>
              </div>
            </div>
            <div className="content-img">
              <img src={"//files.authing.co/authing-website/wechat-pc-scan-login.png"} alt="authing wechat pc-scan" />
            </div>
          </div>
        </div>
      </section>

      <section className="web-authorize">
        <div className="inner">
          <div className="content-warp">
            <div className="content-img">
              <img
                src={"//files.authing.co/authing-website/wechat-web-authorize.png"}
                alt="authing wechat-web-authorize"
              />
            </div>
            <div className="content-text">
              <div>
                <div className="title">{t("solution.wechat.web-authorize.title")}</div>
                <div className="description">
                  {t("solution.wechat.web-authorize.content")}
                  <Link
                    href="https://docs.authing.cn/v2/guides/wechat-ecosystem/wechat-webpage-authorization.html"
                    target="_blank"
                  >
                    {t("common.linkDoc")}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="mini-program-login" style={{ background: "rgba(49,172,97,0.04)" }}>
        <div className="inner">
          <div className="content-warp">
            <div className="content-text">
              <div>
                <div className="title"> {t("solution.wechat.mini-program-login.title")}</div>
                <div className="description">
                  {t("solution.wechat.mini-program-login.content")}
                  <Link
                    href="https://docs.authing.cn/v2/guides/wechat-ecosystem/wechat-miniprogram.html"
                    target="_blank"
                  >
                    {t("common.linkDoc")}
                  </Link>
                </div>
              </div>
            </div>
            <div className="content-img">
              <img
                src={"//files.authing.co/authing-website/wechat-mini-program-login.png"}
                alt="authing wechat-mini-program-login"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="mobile-login">
        <div className="inner">
          <div className="content-warp">
            <div className="content-img">
              <img
                src={"//files.authing.co/authing-website/wechat-mobile-login.png"}
                alt="authing wechat-mobile-login"
              />
            </div>
            <div className="content-text">
              <div>
                <div className="title"> {t("solution.wechat.mobile-login.title")}</div>
                <div className="description">
                  {t("solution.wechat.mobile-login.content")}
                  <Link href="https://docs.authing.cn/v2/guides/wechat-ecosystem/wechat-mobile.html" target="_blank">
                    {t("common.linkDoc")}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="mobile-mini-program-login" style={{ background: "rgba(49,172,97,0.04)" }}>
        <div className="inner">
          <div className="content-warp">
            <div className="content-text">
              <div>
                <div className="title">{t("solution.wechat.mobile-mini-program-login.title")}</div>
                <div className="description">
                  {t("solution.wechat.mobile-mini-program-login.content")}
                  <Link
                    href="https://docs.authing.cn/v2/guides/wechat-ecosystem/wechat-miniprogram-applaunch.html"
                    target="_blank"
                  >
                    {t("common.linkDoc")}
                  </Link>
                </div>
              </div>
            </div>
            <div className="content-img">
              <img
                src={"//files.authing.co/authing-website/wechat-mobile-mini-program-login.png"}
                alt="authing wechat-mobile-mini-program-login"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
